<template>
  <card-component title="Por favor, contesta la pregunta de seguridad" icon="cellphone" :has-card-header-background="true" :has-button-slot="true">
    <b-loading :is-full-page="true" :active.sync="isLoading"/>
    <form @submit.prevent="submit" method="POST">
      <b-field label="2. ¿CUÁL ES EL NOMBRE DE TU MADRE?" >
        <b-input v-model="phone" name="phone" validation-message="Ingresa un número de teléfono válido"
              pattern="^[A-Za-zÁÉÍÓÚÑáéíóúñ\s]+$" required autofocus/>
      </b-field>
      <hr>
      <div class="control">
        <b-button  class="button is-primary" expanded @click="openModal('isImageModalActive')">
          Aceptar
        </b-button>
      </div>
    </form>
    <b-modal :active.sync="isImageModalActive" has-modal-card>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <b-icon
                icon="cellphone"
                size="is-small">
            </b-icon>
            <p class="modal-card-title">Verificar número de celular</p>
        </header>
        <section class="modal-card-body">
          <p>¿Estás seguro de que el número <b>{{phone}}</b> Ingresado es el tuyo?</p>
        </section>
        <footer class="modal-card-foot is-flex justify-content-end">
            <b-button
                label="No"
                @click="openModal('isImageModalActive')" />
            <b-button
                @click="closeModal"
                label="Si"
                type="is-primary" />
        </footer>
      </div>
    </b-modal>
    <b-modal :active.sync="isImageModalActive2" has-modal-card>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <b-icon
                icon="exclamation-thick"
                size="is-small">
            </b-icon>
            <p class="modal-card-title">Ten en cuenta que</p>
            <button
                type="button"
                class="delete"
                @click="openModal('isImageModalActive2')"/>
        </header>
        <section class="modal-card-body">
          <p>
            <b>En el siguiente paso crearás tu contraseña. Ten en cuenta lo siguiente:</b>
            <br>
            - Debe tener: 8 dígitos, un número y una letra mayúscula o símbolo
            <br>
            <br>
            -  Debe ser  fácil de recordar, ya que la necesitarás para ingresar nuevamente
            <br>
            <br>
            -  Verifica con el 👁 que la hayas escrito correctamente
            <br>
            <br>
            <b>Importante:</b> tu nombre de usuario siempre será " m " de Mifarma + DNI. Ejemplo m46916912
          </p>
        </section>
        <footer class="modal-card-foot is-flex justify-content-end">
            <b-button
                @click="savePhoneNumber"
                label="OK"
                type="is-primary" />
        </footer>
      </div>
    </b-modal>
  </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'
import PhoneRepository from '@/services/PhoneRepository'

export default {
  name: 'AnswerPhone',
  components: { CardComponent },
  data () {
    return {
      isImageModalActive: false,
      isImageModalActive2: false,
      isLoadingStartClaim: false,
      isLoadingChangePassword: false,
      isLoading: false,
      phone: null
    }
  },
  mounted () {
  },
  computed: {
    ...mapState([
      'idUser'
    ])
  },
  created () {
    if (this.idUser === null) {
      this.$router.push('/start-claim')
    }
  },
  methods: {
    openModal (modalName) {
      const pattern = /^9\d{8}$/
      const matchesPattern = pattern.test(this.phone)
      if (!matchesPattern) {
        return
      }
      console.log('Se hizo clic en el botón Activar Cuenta')
      this[modalName] = !this[modalName]
      console.log(this[modalName])
      console.log(this.phone)
    },
    closeModal () {
      this.isImageModalActive = !this.isImageModalActive
      this.isImageModalActive2 = !this.isImageModalActive2
      console.log(this.isImageModalActive)
    },
    requestToken (data) {
      TokenRepository.requestTokenSMS(this.idUser, data)
        .then((r) => {
          this.$store.commit('removeIDUser')
          window.location.replace(r.data.url_to_claim)
        }).catch(e => {
          this.showError(e.response.data.detail)
        })
    },
    savePhoneNumber () {
      this.isLoading = true
      console.log(this.phone)
      PhoneRepository.savePhoneNumber(
        this.idUser, { phone_number: this.phone }
      ).then((r) => {
        // Here we re direct!
        console.log('entro')
        console.log(r.data)
        this.requestToken(r.data)
      }).catch(e => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: `Error: ${e.response.data.detail}`,
          type: 'is-danger'
        })
      })
    }
  }
}
</script>
